"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

import { SupportChatView } from "../components/SupportChatView";
import { useCrispChat } from "../hooks/useCrispChat";

import { ScrollArea } from "@/components/ui/scroll-area";

export default function TechnicalSupportPage() {
  const { t } = useTranslation(["support"]);
  const { isLoading, isConnected, embedUrl, iframeRef } = useCrispChat();

  return (
    <ScrollArea className="h-[calc(100dvh_-_4rem)]">
      <div className="bg-background min-h-dvh">
        <div className="mx-auto max-w-4xl px-4 py-8">
          {/* Header */}
          <motion.div animate={{ opacity: 1, y: 0 }} className="mb-8 text-center">
            <h1 className="text-accent-foreground mb-2 text-3xl font-bold">
              {t("support:pageTitle")}
            </h1>
            <p className="text-muted-foreground">{t("support:pageSubtitle")}</p>
          </motion.div>

          {/* Chat Section */}
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            className="rounded-lg bg-transparent shadow-sm"
          >
            <div className="h-[700px] p-3">
              <SupportChatView
                embedUrl={embedUrl}
                iframeRef={iframeRef}
                isConnected={isConnected}
                isLoading={isLoading}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </ScrollArea>
  );
}
